import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'


interface ModalDeleteCampaignProps extends ModalEditComponentProps { }

const ModalDeleteCampaign: React.FC<ModalDeleteCampaignProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/customer/campaign/deleteCampaign',
        data: {
            id: allRowData?.id,
            active: false
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteCampaign', '¿Seguro que quieres eliminar esta campaña?'),
            subtitle: t('onceDeletedNotRecover', 'Una vez eliminado no podrás recuperarla')
        }} />
    )
}

export default ModalDeleteCampaign